import { register } from "register-service-worker";
if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    // async ready() {
    //   // console.log(
    //   //   "App is being served from cache by a service worker.\n" +
    //   //   "For more details, visit https://goo.gl/AFskqB"
    //   // );
    //   document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);

    //   self.addEventListener('push', e => {
    //     const data = e.data.json();
    //     self.registration.showNotification(data.title, {
    //       body: data.body,
    //       // icon: 'favicon.png',
    //       image: data.image
    //     });
    //   });

    //   const publicVapidKey = 'BGNF4TDSyt9uegGTvvp1rPAnbKqMbjWOA3Kh5avuSj7RhxO5PQXKIUaOQ1sK9V4m4XUR5BueNgUKnQYgzbRsiN8';
    //   // document.getElementById('subscribe').addEventListener('click', async function(e) {

    //   // });
    //   const registration = await navigator.serviceWorker.register('worker.js', { scope: '/' });
    //   const subscription = await registration.pushManager.subscribe({
    //     userVisibleOnly: true,
    //     applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
    //   });
    //   await fetch('https://kambox.kamgoko.com/subscribe', {
    //     method: 'POST',
    //     body: JSON.stringify(subscription),
    //     headers: {
    //       'content-type': 'application/json'
    //     }
    //   });
    //   const urlBase64ToUint8Array = function (base64String) {
    //     const padding = '='.repeat((4 - base64String.length % 4) % 4);
    //     const base64 = (base64String + padding)
    //       .replace(/\-/g, '+')
    //       .replace(/_/g, '/');

    //     const rawData = window.atob(base64);
    //     const outputArray = new Uint8Array(rawData.length);

    //     for (let i = 0; i < rawData.length; ++i) {
    //       outputArray[i] = rawData.charCodeAt(i);
    //     }
    //     return outputArray;
    //   }
    // },
    registered() {
      // console.log("Service worker has been registered.");
    },
    cached() {
      // console.log("Content has been cached for offline use.");
      //   elf.addEventListener('fetch', (event) => {
      //     event.respondWith(
      //        caches.match(event.request).then((cacheResponse) => {
      //           return cacheResponse || fetch(event.request).then((response) => {
      //              caches.open('v1').then((cache) => {
      //                 cache.put(event.request, response);
      //              });     
      //              return response.clone();
      //           });
      //        })
      //     );
      //  });
    },
    updatefound() {
    },
    updated() {
    },
    offline() {

    },
    error(error) {
      // console.error("Error during service worker registration:", error);
    }
  });
}
